
export default {
  data() {
    return {
      // Shown by CardsAutoRecommend if Algolia returns no relevant results.
      // Used across all country guide pages via this layout.
      fallbackArticles: [
        {
          objectID: 'fallback-1',
          url: 'https://www.tefl.org/teach-english-abroad/',
          title: 'Teaching English Abroad - The Complete Guide',
          excerpt: 'Everything you need to know about teaching English abroad. From the best countries to teach in, to how to get qualified and find a job.'
        },
        {
          objectID: 'fallback-2',
          url: 'https://www.tefl.org/efl-teacher/',
          title: 'How to become an EFL teacher',
          excerpt: 'Everything you wanted to know about teaching EFL from the world’s most accredited TEFL course provider.'
        },
        {
          objectID: 'fallback-3',
          url: 'https://www.tefl.org/teach-english-abroad/salary/',
          title: 'A Guide to Salaries in 2026',
          excerpt: 'Where are the highest salaries for TEFL teachers abroad? Here’s our detailed guide to wages for teaching English around the world!'
        }
      ]
    }
  },
  computed: {
    page() {
      return this.$store.state.pages.page
    },
    // The get_guide content block already carries the correct modal id per page
    // (e.g. modal="GuidesTeflEuropeGuide") - reuse it here so the sidebar CTA
    // and modal always agree with the in-content "Get the guide" button.
    // A page can have more than one get_guide block (e.g. a region guide plus
    // an unrelated Salary/Online guide), so only match against the continent
    // guides and ignore topic guides like Salary/Online.
    guideModal() {
      const continentModals = [
        'GuidesTeflAsiaGuide',
        'GuidesTeflEuropeGuide',
        'GuidesTeflLatinAmericaGuide',
        'GuidesTeflMiddleEastGuide',
        'GuidesTeflWorldGuide',
      ]
      // Raw page content still has WordPress shortcode syntax, e.g.
      // [get_guide heading="..." modal="GuidesTeflEuropeGuide" ...] -
      // this runs before the [shortcode] -> <component> conversion further
      // down the render pipeline, so match square-bracket syntax here.
      const regex = /\[get_guide\b[^\]]*\bmodal=["']([^"']+)["']/gi
      const content = this.page.content || ''
      let match
      while ((match = regex.exec(content))) {
        if (continentModals.includes(match[1])) return match[1]
      }
      return 'GuidesTeflWorldGuide'
    },
    guideRegionLabel() {
      const label = this.guideModal
        .replace(/^GuidesTefl/, '')
        .replace(/Guide$/, '')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
      return ['World', 'Middle East'].includes(label) ? `the ${label}` : label
    }
  }

  // mounted() {
  //   const self = this
  //   self.$nextTick(function() {
  //     document.querySelectorAll('#country-guide-content img').forEach(function(img) {
  //       img.style.opacity = '0'
  //       img.style.transform = 'translateY(24px)'
  //       img.style.transition = 'opacity 0.6s ease, transform 0.6s ease'

  //       new IntersectionObserver(function(entries, obs) {
  //         if (entries[0].isIntersecting) {
  //           img.style.opacity = '1'
  //           img.style.transform = 'translateY(0)'
  //           obs.disconnect()
  //         }
  //       }, { threshold: 0.1 }).observe(img)
  //     })
  //   })
  // }
}
